<template>
    <div id="uploads-table">
        <v-row class="page-container mb-3 px-0 mt-4 hidden-sm-and-up">
            <h4 class="fs-16" style="color: #363e59;">{{ $t('Передача показаний') }}</h4>
        </v-row>

        <v-row class="page-container mb-3 px-0 mt-4" no-gutters>
            <v-col cols="12" sm="4" class="px-0">
                <slot></slot>
            </v-col>

            <v-col cols="12" sm="4"></v-col>

            <v-col cols="12" sm="4" class="px-0 d-flex justify-end">
                <UploadsTableFilter @filter="addFilter" />
            </v-col>
        </v-row>

        <v-data-table
            :expanded.sync="expanded"
            item-key="record_id"
            :loading="uploadsLoading"
            :single-expand="true"
            :items="uploadsListTranslated"
            :headers="headers"
            :options.sync="formListPagination"
            :server-items-length="uploadsLength"
            :footer-props="{ 'items-per-page-options': $vuetify.breakpoint.xsOnly ? [1] : [10, 15, 20, 25] }"
            ref="table"
        >
            <template v-slot:item.load_date="{ item }">
                <table-cell-tooltip :header="headers[0]" :item="item" filter="formatDateFull">
                    <v-btn class="mr-1" icon @click.stop="expanded.includes(item) ? (expanded = []) : (expanded = [item])">
                        <v-icon :color="$vuetify.theme.themes.dark.primary">{{ expanded.includes(item) ? 'expand_less' : 'expand_more' }}</v-icon>
                    </v-btn>
                    <span @click="openDetailsPage(item)">{{ item.load_date | formatDateFull }}</span>
                </table-cell-tooltip>
            </template>
            <template v-slot:item.status_date="{ item }">
                <table-cell-tooltip :header="headers[1]" :item="item" filter="formatDateFull">
                    <div @click="openDetailsPage(item)">{{ item.status_date | formatDateFull }}</div>
                </table-cell-tooltip>
            </template>
            <template v-slot:item.user_data_name="{ item }">
                <table-cell-tooltip :header="headers[2]" :item="item">
                    <div @click="openDetailsPage(item)">{{ item.user_data_name }}</div>
                </table-cell-tooltip>
            </template>
            <template v-slot:item.status_name.name="{ item }">
                <table-cell-tooltip :header="headers[3]" :item="item">
                    <div @click="openDetailsPage(item)" :class="{ 'error-cell': isErrorCell(item.status_name) }">{{ item.status_name.name }}</div>
                </table-cell-tooltip>
            </template>
            <template v-slot:item.preview_meters_id="{ item }">
                <table-cell-tooltip :header="headers[4]" :item="item" filter="showArrayAsText">
                    <div @click="openDetailsPage(item)">{{ item.preview_meters_id | showArrayAsText }}</div>
                </table-cell-tooltip>
            </template>
            <template v-slot:item.preview_meters_number="{ item }">
                <table-cell-tooltip :header="headers[5]" :item="item" filter="showArrayAsText">
                    <div @click="openDetailsPage(item)">{{ item.preview_meters_number | showArrayAsText }}</div>
                </table-cell-tooltip>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="pa-0">
                    <UploadsTableInnerTable :item="item" :key="item.record_id" />
                </td>
            </template>
        </v-data-table>
        <table-arrows :table="$refs.table"></table-arrows>
    </div>
</template>

<script>
import UploadsTableInnerTable from './UploadsTableInnerTable';
import UploadsTableFilter from './UploadsTableFilter';
import translate from '@/utils/translate.util';
import ErrorCellValidator from '@/mixins/ErrorCellValidator';
import TableCellTooltip from '@/components/ui/TableCellTooltip';
import TableArrows from '@/components/ui/TableArrows';
import { mapActions, mapState } from 'vuex';

export default {
    components: { UploadsTableInnerTable, UploadsTableFilter, TableCellTooltip, TableArrows },
    mixins: [ErrorCellValidator],
    data: () => ({
        expanded: [],
        resetFilter: false
    }),
    async mounted() {
        this.$watch(
            '$vuetify.breakpoint.xsOnly',
            (newVal, oldVal) => {
                if (newVal === oldVal) {
                    return;
                }
                if (newVal) {
                    this.formListPagination.itemsPerPage = 1;
                }
                if (oldVal) {
                    this.formListPagination.itemsPerPage = 10;
                }
                this.formListPagination.page = 1;
            },
            { immediate: true }
        );
        this.getUploadsList();
        this.getServorgsUsers();
        this.getStatusList();
    },
    watch: {
        formListPagination: 'getUploadsList'
    },

    computed: {
        ...mapState('uploads', ['uploadsList', 'uploadsLength', 'uploadsLoading', 'filter']),
        formListPagination: {
            get() {
                return this.$store.state.uploads.formListPagination;
            },
            set(val) {
                this.$store.commit('uploads/setFormListPagination', val);
            }
        },
        uploadsListTranslated() {
            let response = translate(this.uploadsList, 'full', this.$i18n.locale);
            return response;
        },
        headers() {
            return [
                {
                    text: this.$t('Дата загрузки'),
                    value: 'load_date'
                },
                {
                    text: this.$t('Дата отработки'),
                    value: 'status_date'
                },
                {
                    text: this.$t('Пользователь'),
                    value: 'user_data_name'
                },
                {
                    text: this.$t('Статус'),
                    value: 'status_name.name'
                },
                {
                    text: this.$t('ID ПУТЭ'),
                    value: 'preview_meters_id'
                },
                {
                    text: this.$t('Номера ПУТЭ'),
                    value: 'preview_meters_number'
                }
            ];
        }
    },
    methods: {
        ...mapActions('uploads', ['getUploadsList', 'getServorgsUsers', 'getStatusList']),
        addFilter(val) {
            this.formListPagination = {
                itemsPerPage: this.$vuetify.breakpoint.xsOnly ? 1 : 10,
                page: 1,
                sortBy: []
            };
            this.$store.commit('uploads/setFilter', val);
            this.getUploadsList();
        },
        clearFilter() {
            this.resetFilter = true;
            // this.formListPagination = {
            //     itemsPerPage: 10,
            //     page: 1
            // };
            this.$store.commit('uploads/setFilter', null);
            // this.getUploadsList();
            setTimeout(() => {
                this.resetFilter = false;
            }, 500);
        },
        openDetailsPage(item) {
            this.$router.push({ name: 'UploadsDetail', params: { id: item.record_id } });
        }
    }
};
</script>

<style>
.action-buttons {
    border-radius: 15px;
    background: #363e59;
    padding: 20px;
}
#uploads-table .page-container {
    max-width: 100% !important;
}
.pointer {
    cursor: pointer;
}
</style>
